import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const fontColorBasedOnBackground = ribbonColor => {
  let hex = ribbonColor.slice(1);
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
};

const RibbonTagWrapper = styled.div`
  background-color: ${props => props.color};
  font-size: 11px;
  max-width: 90%;
  height: ${props => `${props.height}px`};
  position: relative;
  opacity: 1;
  padding: 6px 11px 0px 11px;
  left: 0;
`;

const RibbonTagText = styled.p`
  color: ${props => fontColorBasedOnBackground(props.color)};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: normal;
  font-family: 'Avenir Next Airbo';
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RibbonTagArrowBase = styled.div`
  width: 0;
  height: 0;
  border-left: ${props => `${props.height / 2}px solid transparent`};
  border-right: ${props => `${props.height / 2}px solid transparent`};
  position: absolute;
  right: ${props => `-${props.height / 2}px`};
`;

const RibbonTagArrowTop = styled(RibbonTagArrowBase)`
  border-bottom: ${props => `${props.height}px solid ${props.color}`};
  bottom: 0;
`;

const RibbonTagArrowBottom = styled(RibbonTagArrowBase)`
  border-top: ${props => `${props.height}px solid ${props.color}`};
  top: 0;
`;

const RibbonTagComponent = props => (
  <RibbonTagWrapper
    id="ribbon-tag"
    color={props.ribbonTagColor}
    height={props.height}
    onClick={() => hideRibbonTag(props.hideRibbonTag)}
  >
    <RibbonTagText className="ribbon-text" color={props.ribbonTagColor}>
      {props.ribbonTagName}
    </RibbonTagText>
    <RibbonTagArrowTop height={props.height} color={props.ribbonTagColor} />
    <RibbonTagArrowBottom height={props.height} color={props.ribbonTagColor} />
  </RibbonTagWrapper>
);

RibbonTagComponent.propTypes = {
  height: PropTypes.string.isRequired,
  ribbonTagName: PropTypes.string.isRequired,
  ribbonTagColor: PropTypes.string.isRequired,
  hideRibbonTag: PropTypes.string,
};

export default RibbonTagComponent;
